import { render, staticRenderFns } from "./FormationIndex.vue?vue&type=template&id=46cb415f&"
import script from "./FormationIndex.vue?vue&type=script&lang=js&"
export * from "./FormationIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports